var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.statusName || _vm.isWithdrawal)?_c('b-badge',{attrs:{"variant":_vm.variant,"pill":""}},[_vm._v(" "+_vm._s(_vm.displayText)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }